/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

const MembersServices = {
    getMembers: (query) => fetch(`/api/members/?query=${encodeURIComponent(query)}`, options),
    getMember: (id) => fetch(`/api/members/${id}`, options),
    postMember: (member) =>
        fetch(`/api/members/`, Object.assign({}, options, {
            method: 'POST',
            body: JSON.stringify(member)
        })),
    deleteMember: (id) =>
        fetch(`/api/members/${id}`, Object.assign({}, options, {
            method: 'DELETE'
        }))
};

export default {
    MembersServices
};